<template>
    <div>
        <!-- display lab history -->
        <div v-if="testResultHistory.length > 0">
            <table class="table b-table list table-hover table-borderless">
                <thead>
                    <tr>
                        <th width="40%">Record:</th>
                        <th>Result:</th>
                        <th class="text-nowrap">Reference Range:</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody
                    v-for="(item, iindex) in testResultHistory"
                    :key="iindex"
                >
                    <tr>
                        <td>
                            <router-link :to="`/patient/lab/${item.recordId}`">
                                {{ item.recordDate }}
                            </router-link>
                        </td>
                        <td>
                            <span
                                :class="setAbaxisAbnormalCode(item)"
                                v-html="item.value"
                            ></span>
                            <span
                                v-if="item.comment"
                                v-html="decodeHtml(item.comment)"
                            ></span>
                        </td>
                        <td v-html="item.range"></td>
                        <td>
                            <lab-reference-range
                                v-if="item && item.pct"
                                :percentage="item.pct"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import { has } from "lodash";
import EXTENSIONS from "@/constants/extensions";
import LabReferenceRange from "@/components/commons/lab-reference-range";

export default {
    components: {
        LabReferenceRange
    },
    props: {
        labId: {
            type: String
        },
        testResultHistory: {
            type: Array
        }
    },
    data() {
        return {};
    },
    watch: {},
    computed: {},
    beforeDestroy() {},
    methods: {
        getLabLink(id) {
            return "/view/patient/lab/" + id;
        },
        decodeHtml(html) {
            var txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        },
        setAbaxisAbnormalCode(data) {
            if (
                has(data, "abnormal") &&
                data.abnormal &&
                data.source == EXTENSIONS.CODE.CODE_ABAXIS_FUSE
            ) {
                return "text-danger";
            }
        }
    }
};
</script>
<style scoped></style>
